export default __webpack_public_path__ + "static/media/spwn-capsule-tif.82a24bd5.png";